import React, { useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import * as xlsx from "xlsx";
import { toast } from "react-toastify";
import UnlockShiptoManagementAPI from "apis/UnlockShiptoManagement/UnlockShiptoManagement";

export default function UploadShipto() {
  const history = useHistory();
  const { uploadUnlockShipto } = UnlockShiptoManagementAPI();
  const fileInputRef = useRef(null);

  const [fileData, setFileData] = useState({
    all: [],
  });
  const [loading, setLoading] = useState(false);
  const [totalFileCount, setTotalFileCount] = useState(0);

  const validStatuses = [
    "Eligible",
    "Hard Ineligible",
    "Ineligible",
    "Hard Eligible",
  ];

  

  const handleInputClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setFileData({ all: [] });
    setTotalFileCount(0);
  };

  const handleFile = (file) => {
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      const workbook = xlsx.read(e.target.result, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const json = xlsx.utils.sheet_to_json(sheet, {
        defval: "",
      });

      const allData = json.map((row, index) => ({
        row: index + 2,
        customer_account_number:
          row.Shipto ??
          row.shipto ??
          row.customer_account_number ??
          row.Customer_Account_Number ??
          row["Customer Account Number"] ??
          "",
        review_status:
          row["Review Status"] ??
          row.review_status ??
          row.Review_Status ??
          "",

          reason:
          row["Program Admin Reason Description"] ??
          row.reason ??
          row.reason??
          "",
      }));

      setFileData({ all: allData });
      setTotalFileCount(allData.length);
    };

    reader.readAsBinaryString(file);
  };

  const handleUpload = async () => {
    try {
      if (!fileData.all?.length) {
        toast.error("No data to upload");
        return;
      }

      const missingRecords = fileData.all.filter(
        (item) =>
          item.customer_account_number === "" ||
          item.customer_account_number === null ||
          item.customer_account_number === undefined ||
          item.review_status === "" ||
          item.review_status === null ||
          item.review_status === undefined 
        

      );

      if (missingRecords.length > 0) {
        toast.error(
          `❌ ${missingRecords.length} record(s) have missing Shipto or Review Status`
        );
        return;
      }

      const invalidStatusRecords = fileData.all.filter(
        (item) =>
          item.review_status &&
          !validStatuses.some(
            (status) =>
              status.toLowerCase().trim() ===
              String(item.review_status).toLowerCase().trim()
          )
      );


      

      if (invalidStatusRecords.length > 0) {
        toast.error(
          `❌ ${invalidStatusRecords.length} record(s) have invalid review_status. Please check the Valid Statuses sheet.`
        );
        return;
      }

     

      setLoading(true);

      const res = await uploadUnlockShipto({
        data: fileData.all,
      });

      setLoading(false);

      if (res) {
        const summary = res.summary || {};

        history.push("/dashboard/unlock-shipto-result", {
          failedData: res.failed,
          summary,
          inserted: res.inserted || 0,
        });

        return;
      }

      toast.error("Upload failed");
    } catch (err) {
      setLoading(false);
      toast.error("Server error");
    }
  };

  const downloadSample = () => {
    const sampleData = [
      { Shipto: 123456, "Review Status": "Eligible","Program Admin Reason Description":"Spark" },
      { Shipto: 234567, "Review Status": "Ineligible","Program Admin Reason Description":"Flex"},
      { Shipto: 345678, "Review Status": "Hard Eligible" },
      { Shipto: 456789, "Review Status": "Hard Ineligible" },
    ];

    const statusData = validStatuses.map((status) => ({
      "Review Status": status,
    }));

     

    const workbook = xlsx.utils.book_new();

    const sampleWorksheet = xlsx.utils.json_to_sheet(sampleData, {
      header: ["Shipto", "Review Status","Program Admin Reason Description"],
    });

    const statusWorksheet = xlsx.utils.json_to_sheet(statusData, {
      header: ["Review Status"],
    });

    xlsx.utils.book_append_sheet(workbook, sampleWorksheet, "Sample Upload");
    //xlsx.utils.book_append_sheet(workbook, statusWorksheet, "Valid Statuses");

    xlsx.writeFile(workbook, "Unlocked_Eligibility_Sample.xlsx");
  };

  return (
    <div style={{ padding: 20, fontFamily: "Arial", position: "relative" }}>
      <button
        onClick={() => history.goBack()}
        style={{
          backgroundColor: "#2f5fb3",
          color: "white",
          border: "none",
          padding: "8px 16px",
          borderRadius: 6,
          cursor: "pointer",
          marginBottom: 10,
          position: "absolute",
          top: 10,
          left: 20,
        }}
      >
        Back
      </button>

      <button
        onClick={downloadSample}
        style={{
          backgroundColor: "#2f5fb3",
          color: "white",
          border: "none",
          padding: "8px 16px",
          borderRadius: 6,
          cursor: "pointer",
          position: "absolute",
          top: 10,
          right: 20,
        }}
      >
        Download Sample File
      </button>

      <div
        style={{
          fontSize: 20,
          fontWeight: "bold",
          marginBottom: 20,
          textAlign: "center",
        }}
      >
        Import Shipto Details
      </div>

      <div style={{ maxWidth: 400 }}>
        <label style={{ display: "block", fontWeight: "bold", marginBottom: 8 }}>
          Upload Excel File:
        </label>

        <input
          ref={fileInputRef}
          type="file"
          accept=".xlsx"
          onClick={handleInputClick}
          onChange={(e) => handleFile(e.target.files[0])}
        />

        <br />
        <br />

        {totalFileCount > 0 && (
          <div style={{ marginBottom: 10, color: "#555" }}>
            Total records in file: {totalFileCount}
          </div>
        )}

        <button
          onClick={handleUpload}
          disabled={loading}
          style={{
            backgroundColor: "#2f5fb3",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: 6,
            cursor: "pointer",
            marginBottom: 20,
          }}
        >
          {loading ? "Uploading..." : "Upload"}
        </button>
      </div>
    </div>
  );
}